var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89967 12.2035C8.64611 12.3788 8.23501 12.3788 7.98145 12.2035L0.190043 6.81731C-0.0635176 6.64202 -0.0635176 6.35783 0.190043 6.18254L7.98145 0.796357C8.23501 0.621072 8.64611 0.621072 8.89967 0.796357C9.15323 0.971644 9.15323 1.25584 8.89967 1.43113L1.56738 6.49993L8.89967 11.5687C9.15323 11.744 9.15323 12.0282 8.89967 12.2035Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.e866afb7e736cd6750f1cd61a6dde20f.svg";
export { ForwardRef as ReactComponent };